import * as constants from '../../constants';

const INITIAL_STATE = {
    item: null,
    items: [],
    page: 1,
    count: 0,
    error: null,
    loading: false,
    submitting: false,
    filterText: '',
    sortBy: '',
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;
        case constants.ADMIN_USER_LIST_REQUESTED:
            return Object.assign({}, state, {loading: true});
        case constants.ADMIN_USER_LIST_SUCCESS:
            return Object.assign({}, state, {loading: false, items: action.payload.data.items, count: action.payload.data.count, error: null});
        case constants.ADMIN_USER_LIST_FAILURE:
            return Object.assign({}, state, {loading: false, items: [], count: 0, error: action.payload.error});
        case constants.ADMIN_USER_LIST_CHANGE_PAGE:
            return Object.assign({}, state, {page: action.payload.page});
        case constants.ADMIN_USER_CREATE_REQUESTED:
            return Object.assign({}, state, {submitting: true, error: null});
        case constants.ADMIN_USER_EDIT_REQUESTED:
            return Object.assign({}, state, {submitting: true, error: null});
        case constants.ADMIN_USER_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null, item: null});
        case constants.ADMIN_USER_SUCCESS:
            return Object.assign({}, state, {loading: false, submitting: false, item: action.payload.data, error: null});
        case constants.ADMIN_USER_FAILURE:
            return Object.assign({}, state, {loading: false, submitting: false, error: action.payload.error});
        case constants.ADMIN_USER_LIST_CHANGE_FILTER:
            return Object.assign({}, state, {filterText: action.payload.filterText, sortBy: action.payload.sortBy});
    }
    return state;
}
